import React, { useState } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";

import { Row, Col, Form } from "react-bootstrap";
import Sallie from "../UIComponents/Sallie";
import LabelledInput from "../UIComponents/LabelledInput";
import DisabledButton from "../UIComponents/DisabledButton";

import { ForgotPasswordSchema } from "./validations/authenticationSchema";
import { sendResetPwEmail } from "../../api/helpReq";

const ForgotPassword = () => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [sallieMsg, setSallieMsg] = useState(null);

  const { register, handleSubmit, errors, formState } = useForm({
    resolver: yupResolver(ForgotPasswordSchema),
  });
  const { touched } = formState;

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      data.email = data.email.toLowerCase();
      await sendResetPwEmail(data);
      setSallieMsg(`${t("forgotpassword.sallie.email_sent")} ${data.email}.`);
    } catch (error) {
      console.error("Error sending password reset email:", error);
      if (error.response && error.response.status === 404) {
        setSallieMsg(t("forgotpassword.sallie.no_account"));
      } else {
        setSallieMsg(t("forgotpassword.sallie.error"));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Sallie text={sallieMsg || t("forgotpassword.sallie.reset_password")} />
      <Row className="d-flex justify-content-center">
        <Col xs={10} md={6}>
          <Form
            autoComplete="on"
            method="POST"
            className="mt-2"
            style={{ margin: "0 auto" }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <LabelledInput
              labelAs="h6"
              name="email"
              type="email"
              label={t("signin.email")}
              autoComplete="email"
              inputRef={register}
              errors={errors}
              touched={touched}
            />
            <DisabledButton
              disabled={isLoading}
              className="w-100"
              type="submit"
              variant="outline-primary"
            >
              {t("forgotpassword.continue")}
            </DisabledButton>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default ForgotPassword;